import { useMemo } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import ProductCard from "@/components/ProductCard";
import CollectionSEO from "@/components/CollectionSEO";
import { useProducts } from "@/context/ProductsContext";

export default function Collections() {
  const { products, categories, loading } = useProducts();
  const { section, slug } = useParams();
  const [params] = useSearchParams();
  const q = params.get("q")?.toLowerCase() || "";

  const { title, subtitle, items } = useMemo(() => {
    let items = products;
    let title = "All Collections", subtitle = "The complete edit";
    if (slug) {
      const cat = categories.find(c => c.slug === slug);
      items = products.filter(p => p.category === slug);
      const pretty = slug.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
      title = cat?.name || pretty; subtitle = "House Collection";
    } else if (section) {
      items = products.filter(p => p.section.includes(section));
      title = { women:"Women", menswear:"Menswear", bridal:"Bridal", festive:"Festive", cocktail:"Occasion Wear", new:"New Arrivals" }[section] || section;
      subtitle = "Editorial edit";
    }
    if (q) items = items.filter(p => (p.title + " " + p.subtitle + " " + p.category).toLowerCase().includes(q));
    return { title, subtitle, items };
  }, [products, categories, section, slug, q]);

  return (
    <div className="pt-32 pb-24 bg-ivory min-h-screen" data-testid="collections-page">
      <CollectionSEO slug={slug} section={section} title={title} subtitle={subtitle} items={items} />
      <div className="container-lux">
        <p className="overline text-muted-foreground">{subtitle}</p>
        <h1 className="mt-4 font-serif tracking-tighter text-5xl md:text-7xl font-light">{title}</h1>
        <p className="mt-6 text-sm text-muted-foreground">{items.length} pieces</p>
        <div className="divider-thin my-10" />
        {loading ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-10" data-testid="collections-page-loading">
            {Array.from({ length: 8 }).map((_, i) => <div key={i}><div className="aspect-[3/4] bg-muted animate-pulse" /><div className="mt-4 h-4 w-2/3 bg-muted animate-pulse" /></div>)}
          </div>
        ) : items.length === 0 ? (
          <p className="text-center py-24 text-muted-foreground">No pieces match your search.</p>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-10">
            {items.map(p => <ProductCard key={p.id} product={p} />)}
          </div>
        )}
      </div>
    </div>
  );
}
